import { useMutation } from "@apollo/client";
import { graphql } from "../gql";
import { GetAllOneOnOneAssignmentPdfsQuery } from "./useAllOneOnOneAssignmentPdfs.ts";
import {
  BusinessEnglishObjective,
  OneOnOneLessonType,
  SpeakingClassLevel,
} from "../gql/graphql.ts";

const UpsertOneOnOneAssignmentPdfMutation = graphql(`
  mutation upsertOneOnOneAssignmentPdf(
    $assignmentNumber: Int!
    $level: SpeakingClassLevel!
    $oneOnOneLessonType: OneOnOneLessonType!
    $pdfUrl: String!
    $userGroupId: String!
    $businessEnglishObjective: BusinessEnglishObjective
  ) {
    upsertOneOnOneAssignmentPdf(
      assignmentNumber: $assignmentNumber
      level: $level
      oneOnOneLessonType: $oneOnOneLessonType
      pdfUrl: $pdfUrl
      userGroupId: $userGroupId
      businessEnglishObjective: $businessEnglishObjective
    )
  }
`);

export function useUpsertOneOnOneAssignmentPdf() {
  const [mutate, { loading }] = useMutation(
    UpsertOneOnOneAssignmentPdfMutation,
    {
      refetchQueries: [GetAllOneOnOneAssignmentPdfsQuery],
    },
  );

  return {
    loading,
    upsert: (input: {
      assignmentNumber: number;
      level: SpeakingClassLevel;
      oneOnOneLessonType: OneOnOneLessonType;
      pdfUrl: string;
      userGroupId: string;
      businessEnglishObjective?: BusinessEnglishObjective;
    }) =>
      mutate({
        variables: input,
      }),
  };
}
